module.exports = __webpack_public_path__ + "img/icon-none.9b3dd953.png";